import { useState } from "react"
import $ from "jquery";
import ResultBox from "./ResultBox";
import styles from "./TextMode.module.css";
import text_icon from "./Icons/text.png";

const TextMode = () => {

    const [results, setResults] = useState(false);
    const [resultArray, setResultArray] = useState([]);

    function sendToVerify() {
        const claim_text = document.getElementById("text").value;
        if(claim_text === '') {
            document.getElementById("emptyError").style.display = "flex";
            return false;
        }
        setResults("loading");
        $.ajax({
            url : "https://truthcreds.onrender.com/text/",
            type : 'POST',
            contentType: "application/json",
            data : JSON.stringify({
                claim_text : claim_text,
            }),
            success: function(data) {
                console.log(data['claims']);
                setResultArray(data['claims']);
                setResults(true);
            },
            error: function(xhr, status, error) {
                console.log(error);
            }
        })
    }

    if(results === "loading") {
        return (
            <div style = {{"paddingTop" : "25vh"}} className = {styles.body}>
                <div className = {styles.loader}></div>
                <h3 className = {styles.waiting}>Thank you for waiting! This may take a while...</h3>
            </div>
        )
    }

    if(results === true) {
        let resultList = [];

        resultArray.forEach(result => {
            resultList.push(<ResultBox obj = {result}/>);
        });

        return(
            <div>
                <h1 id = "loading" className = {styles.result_title}>Results</h1>
                {resultList}
            </div>
        )
    }

    return (
        <div div className = {styles.body}>
            <div style = {{"display" : "flex", "flexDirection" : "row", "alignItems" : "center", "justifyContent" : "center"}}>
                <img className = {styles.textIcon} src = {text_icon} alt = "text" />
                <h1 className = {styles.title}>Text</h1>
            </div>
            
            <div className = {styles.input_block}>
                <textarea className = {styles.input_box} type = "text" placeholder = "Insert Text To Verify" id = "text" rows = "10"></textarea>
                <h3 id = "emptyError" className ={styles.errorMsg} style = {{"display" : "none", "margin" : 0}}>This field cannot be empty!</h3>
                <button className = {styles.button} onClick = {sendToVerify}>VERIFY</button>
            </div>
        </div>
        
    )
}

export default TextMode;